if (!customElements.get('popstamp-country-selector')) {
  customElements.define('popstamp-country-selector', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.addEventListener('submit', (event) => {
        const giftcards = {
          GB: 'giftcard-popstamp',
          PT: 'giftcard-popstamp-euro',
          AT: 'giftcard-popstamp-euro',
          NL: 'giftcard-popstamp-euro',
          PL: 'giftcard-popstamp-euro',
          FR: 'carte-cadeau-popstamp',
          DE: 'popstamp-geschenkkarten',
          IT: 'buono-regalo-popstamp',
          ES: 'tarjeta-regalo-popstamp'
        };
        const currentHandle = window.location.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
        if (!Object.values(giftcards).includes(currentHandle)) return;

        const form = event.target;
        const giftcard = giftcards[form.elements.country_code.value];
        if (giftcard) form.elements.return_to.value = `/products/${giftcard}`;
      }, options);

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          event.stopPropagation();
          this.details.open = false;
          this.trigger.focus();
        }
      }, options);

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.details.open = false;
      }, options);

      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) {
          this.details.open = false;
        }
      }, options);

      // Close a desktop panel before its header is hidden on mobile (and vice versa).
      window.addEventListener('resize', () => { this.details.open = false; }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
